var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunchingIcon3(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.466,
    height: 133.466,
    viewBox: "0 0 133.466 133.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(-1050.5 -638.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M61.2,7.982a17.008,17.008,0,0,0-24.058,0L33.868,11.26,30.59,7.982A17.012,17.012,0,0,0,6.531,32.041l3.278,3.278L33.868,59.377,57.926,35.319,61.2,32.041a17.008,17.008,0,0,0,0-24.058Z",
    transform: "translate(1087.951 673.502)",
    fill: "none",
    stroke: "#5090bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "message-circle",
    d: "M128.466,62.248a58.411,58.411,0,0,1-6.273,26.487A59.248,59.248,0,0,1,69.218,121.5a58.411,58.411,0,0,1-26.487-6.273L3,128.466,16.244,88.735A58.411,58.411,0,0,1,9.97,62.248,59.248,59.248,0,0,1,42.731,9.273,58.412,58.412,0,0,1,69.218,3H72.7a59.108,59.108,0,0,1,55.763,55.763Z",
    transform: "translate(1051.5 639.5)",
    fill: "none",
    stroke: "#5090bb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchingIcon3);
export default __webpack_public_path__ + "static/media/launching-icon3.e9be48e34e6dfb9de543f324d202db94.svg";
export { ForwardRef as ReactComponent };